export default __webpack_public_path__ + "static/media/cancel-ticket.d01be652.svg";